import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import LanguageSelect from "../LanguageSelect";
import { createMemory } from "../../../redux/ducks/memory";
import Progress from "../../../helpers/progress";
import useTargets from "../../../hook/useTargets";
import TextInput from "../../dumb/TextInput";
import AreaInput from "../../dumb/AreaInput";
import * as XLSX from "xlsx";

const CreateMemory = (props) => {
  const [show, hide, renderModal] = useModal();
  const [d_createMemory, status, error, event] = useStatusThunk(createMemory);
  const [isUploading, setIsUploading] = useState(false);

  const [targets, renderButton, renderTargets, setTargets] = useTargets({
    disabled: isUploading, // Pass isUploading to disable the button
  });

  const [name, setName] = useState();
  const [note, setNote] = useState("");
  const [sourceLang, setSourceLang] = useState();
  const [sourceColumn, setSourceColumn] = useState(null);
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [hideCloseButton, setHideCloseButton] = useState(false);

  let intId;

  const progressInterval = async () => {
    const progressValue = await Progress(); // Call the async function and wait for the result
    setProgress(progressValue.progress);
  };

  const startProgressInterval = () => {
    if (!intId) {
      intId = setInterval(progressInterval, 2000); // Start the interval
    }
  };

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);

    if (uploadedFile) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryStr = event.target.result;

        try {
          // Read the file and calculate row count
          const workbook = XLSX.read(binaryStr, { type: "binary" });
          const sheetName = workbook.SheetNames[0]; // Get the first sheet
          const worksheet = workbook.Sheets[sheetName];
          const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // Get rows as arrays
          setRowCount(data.length); // Set the row count
        } catch (error) {
          console.error("Error reading file:", error);
          setRowCount(0); // Reset on error
        }
      };
      reader.readAsArrayBuffer(uploadedFile); // Read the file as binary
    }
  };

  const targetsPayload = targets
    .filter((t) => t?.col && t?.lang)
    .map((t) => ({ col: t.col, lang: t.lang }));

  event.onPending = () => {
    startProgressInterval();
    setHideCloseButton(true);
    setIsUploading(true);
  };

  event.onFailure = () => {
    if (intId) {
      clearInterval(intId); // Clear the interval
      intId = null; // Reset the interval ID
    }
    setHideCloseButton(false);
    setIsUploading(false);
  };

  event.onSuccess = () => {
    if (intId) {
      clearInterval(intId); // Clear the interval
      intId = null; // Reset the interval ID
    }
    hide();
    clearInterval(intId);
    setName(null);
    setNote(null);
    setSourceLang(null);
    setSourceColumn(null);
    setFile(null);
    setProgress(null);
    setRowCount(0); // Reset row count on success
    setTargets([]);
    setHideCloseButton(false);
    setIsUploading(false);
  };

  return (
    <React.Fragment>
      <button
        className={"button button--memory " + props.className}
        onClick={show}
      >
        Create Memory
      </button>
      {renderModal(
        <React.Fragment>
          <div className="group">
            <div className="label">Memory name</div>
            <TextInput disabled={isUploading} set={setName} v={name} />
          </div>

          <div className="group">
            <div className="label">Note</div>
            <AreaInput disabled={isUploading} set={setNote} v={note} />
          </div>

          <div className="double-inputs">
            <div className="group">
              <div className="label">Src lang</div>
              <LanguageSelect
                disabled={isUploading}
                selected={sourceLang}
                onChange={(e) => setSourceLang(e.target.value)}
              />
            </div>

            <div className="group">
              <div className="label">src col</div>
              <TextInput
                disabled={isUploading}
                set={setSourceColumn}
                v={sourceColumn}
              />
            </div>
          </div>

          {renderButton()}
          {renderTargets()}

          <div className="group">
            <div className="label">XLSX</div>
            <input
              type="file"
              accept=".xlsx"
              disabled={isUploading}
              onChange={handleFileChange}
            />
          </div>

          <div className="group">
            <DisplayError error={error} />
          </div>

          <LoadingButton
            loading={status == "pending"}
            className="button--primary"
            progress={progress}
            onClick={(e) => {
              d_createMemory({
                name,
                note,
                sourceLang,
                file,
                sourceColumn,
                targets,
                rowCount,
              });
            }}
          >
            Create Memory
          </LoadingButton>
        </React.Fragment>,
        { hideCloseButton }
      )}
    </React.Fragment>
  );
};
export default CreateMemory;
